/* hide and show mobile nav */
document.addEventListener("DOMContentLoaded", function (e) {
    const navIcon = document.querySelector('.menu-toggle');
    const offCanvasMenu = document.querySelector('.nav-primary');
    const closeButton = document.querySelector('.menu-close');


    const subnav = document.querySelector('.subnav-arrow')

    navIcon.onclick = (e) => {
        console.log('click')
        e.stopPropagation();
        e.preventDefault();
        offCanvasMenu.setAttribute('aria-expanded', 'true');
        navIcon.setAttribute('style', 'display:none')
    };

    closeButton.onclick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        offCanvasMenu.setAttribute('aria-expanded', 'false');
        navIcon.setAttribute('style', 'display:block')
    };

    window.onresize = (e) => {
        if (window.matchMedia("(min-width: 600px)").matches) {
            offCanvasMenu.setAttribute('aria-expanded', 'false');
            navIcon.setAttribute('style', 'display:none')
        } else {
            if (offCanvasMenu.getAttribute('aria-expanded') !== 'true') {
                navIcon.setAttribute('style', 'display:block')
            }
        }
    }

})
